import { required, useTranslate } from "ra-core";
import { AutocompleteInput, ReferenceInput } from "@/components/admin";
import { contactOptionText } from "../misc/ContactOption";
import { NoteMessageInput } from "./NoteMessageInput";
export const NoteInputsMobile = ({
  selectContact,
}: {
  selectContact?: boolean;
}) => {
  const translate = useTranslate();
  return (
    <div className="min-w-0 space-y-4">
      <NoteMessageInput
        placeholder={translate("resources.notes.inputs.add_note")}
      />
      {selectContact && (
        <ReferenceInput source="contact_id" reference="contacts">
          <AutocompleteInput
            label="resources.notes.fields.contact_id"
            optionText={contactOptionText}
            helperText={false}
            validate={required()}
            modal
          />
        </ReferenceInput>
      )}
    </div>
  );
};
